// extracted by mini-css-extract-plugin
export default {"Register":"Register_Register__OELgy"};